import type { DirectConvPayload } from '@/features/conversation';
import type { Conversation } from '@/features/conversation/models/conversation';
import type { Member } from '@/features/conversation/models/member';
import type { ZoomToMessagePayload } from '@/features/message-list';
import type { ShowMessageReactionsPayload } from '@/features/messages/components/message-reaction-dialog';
import type { Message } from '@/features/messages/models/message';
import { TypedEmitter } from '@/shared/helpers';

type PermissionConfigPayload = {
  convId: string;
  member: Member;
};

type ChatEvent = {
  'conversation-add': void;
  'conversation-update': string;
  'add-member': string;
  'open-group-settings': Conversation;
  'conversation-create-direct': DirectConvPayload;
  'zoom-to-message': ZoomToMessagePayload;
  'message-forward': Message;
  'show-message-reactions': ShowMessageReactionsPayload;
  'aside-back-to-info': void;
  'permission-config-open': PermissionConfigPayload;
};

export const chatEE = new TypedEmitter<ChatEvent>();

// Rely on centralized HMR manager via TypedEmitter registration; no per-module cleanup needed
// Keep dispose pattern available if code wants to explicitly dispose
// No runtime changes here; TypedEmitter registers itself automatically.
